'use strict';

import Actions from '../actions/DraftServerActionCreators';
import { get, put, post, del } from '../utils/APIUtils';

var DraftAPI = {
  saveDraft(draft) {
    if (draft.uuid) {
      put(`/api/drafts/${draft.uuid}`, draft, Actions.handleSaveDraft, draft.uuid);
    } else {
      post('/api/drafts', draft, Actions.handleSaveDraft, null);
    }
  },

  loadStampInEditor(stampId) {
    get(`/api/stamps/${stampId}`, Actions.handleLoadStampInEditor, stampId);
  },

  loadDraftInEditor(draftUuid) {
    get(`/api/drafts/${draftUuid}`, Actions.handleLoadDraftInEditor, draftUuid);
  },

  deleteDraft(draftUuid) {
    del('/api/drafts/' + draftUuid, Actions.handleDeleteDraft, draftUuid);
  },

  sendFeedback(draftUuid, message) {
    post('/api/drafts/' + draftUuid + '/feedback', { message }, Actions.handleSendFeedback, draftUuid);
  },

  requestDraftsPage(url) {
    url = url || '/api/drafts';
    get(url, Actions.handleDraftsPage);
  },

  requestDraftFeedbacksPage(draftUuid, url) {
    url = url || '/api/drafts/' + draftUuid + '/feedback';
    get(url, Actions.handleDraftFeedbacksPage, draftUuid);
  }
};

export default DraftAPI;


/** WEBPACK FOOTER **
 ** ./api/DraftAPI.js
 **/